export const Modes = {
    CREATE: 'CREATE',
    EDIT: 'EDIT'
};
